/**
 * The table row filter argument placeholder used to indicate it is the logged in user's id
 */
export const LOGGED_IN_USER_FILTER_ARG = 'Logged In User'
